export enum RoleName {
  admin = "admin",
  user = "user",
  developer = "developer",
}

export interface RoleModel {
  id: number;
  name: RoleName;
}
